import React from "react";
import { ICaseDecision } from "../../../caseDecisions/model/CaseDecision";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { Button, Col, Divider, Form, Radio, Row, Space } from "antd";
import Text from "antd/lib/typography/Text";
import DateTimePicker from "../../../core/ui/components/DateTimePicker";
import { DateFormats } from "../../../core/common/Constants";
import moment from "moment";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import SelectInput from "../../../core/ui/components/SelectInput";
import { ICourtCase } from "../../model/CourtCase";

export interface Props {
  caseDecisions: ICaseDecision[];
  translate: TTranslate;
  hint?: string;
  onSelectDecision?(item: ICaseDecision): void;
  selectedCaseDecision?: ICaseDecision;
  decisionTypes?: IGenericCodebookItem[];
  courtCase: ICourtCase;
}

const CaseDecisionSelectionGroup: React.FC<Props> = ({
  translate,
  caseDecisions,
  onSelectDecision,
  hint,
  selectedCaseDecision = caseDecisions[0],
  decisionTypes,
  courtCase
}: Props) => {
  return (
    <>
      <p>
        <Text type="secondary">{hint}</Text>
      </p>
      {selectedCaseDecision && (
        <>
          <Row align="middle">
            <Col span={10}>
              <Form.Item
                label={translate("editors.case_decisions.decision_date")}
                initialValue={
                  selectedCaseDecision?.decisionDate
                    ? moment(selectedCaseDecision?.decisionDate)
                    : null
                }
                name={["decisionDate", selectedCaseDecision?.id]}
                rules={[
                  {
                    required: true,
                    message: translate(
                      "editors.case_law_documents.required_messages",
                      {
                        field: translate(
                          "editors.case_law_documents.case_law_document_type"
                        )
                      }
                    )
                  }
                ]}
              >
                <DateTimePicker
                  onChange={(value) => {
                    selectedCaseDecision.decisionDate = value;
                    selectedCaseDecision.valid = true;
                    onSelectDecision?.(selectedCaseDecision);
                  }}
                  placeholder={translate(
                    "editors.case_decisions.select_decision_date"
                  )}
                  format={DateFormats.DATE}
                  showToday={true}
                  className={"input-date-wrapper"}
                  translate={translate}
                  value={selectedCaseDecision.decisionDate}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              {selectedCaseDecision?.attachmentId ? (
                <Button
                  type="link"
                  href={`/api/case-decisions/attachments/${selectedCaseDecision?.attachmentId}/download`}
                  icon={<i className="fa fa-download" aria-hidden="true" />}
                >
                  {translate(
                    "editors.case_law_documents.connected_cases.download"
                  )}
                </Button>
              ) : selectedCaseDecision?.id ? (
                <Button
                  type="link"
                  href={`/api/case-decisions/${selectedCaseDecision?.extId}/attachments/courtCase/${courtCase.courtCaseNumber}/download`}
                  icon={<i className="fa fa-download" aria-hidden="true" />}
                >
                  {translate(
                    "editors.case_law_documents.connected_cases.download"
                  )}
                </Button>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <Form.Item
                label={translate("editors.case_decisions.decision_type")}
                initialValue={selectedCaseDecision?.decisionTypeId}
                name={["decisionTypeId", selectedCaseDecision?.id]}
                rules={[
                  {
                    required: true,
                    message: translate(
                      "editors.case_law_documents.required_messages",
                      {
                        field: translate(
                          "editors.case_law_documents.case_law_document_type"
                        )
                      }
                    )
                  }
                ]}
              >
                <SelectInput
                  placeholder={translate(
                    "editors.attachment_types.select_content_type"
                  )}
                  allowClear
                  showSearch={true}
                  notFoundContent={translate("search.no_data")}
                  selectOptionKey={"id"}
                  selectOptionValue={"value"}
                  selectOptions={decisionTypes}
                  value={selectedCaseDecision.decisionTypeId}
                  onChange={(value) => {
                    selectedCaseDecision.decisionTypeId = value;
                    selectedCaseDecision.valid = true;
                    onSelectDecision?.(selectedCaseDecision);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}

      <Divider></Divider>
      <Radio.Group
        style={{ marginLeft: 36 }}
        onChange={(e) => {
          let value = caseDecisions.find(
            (item) => item.id.toString() === e.target.value
          );
          if (value) {
            onSelectDecision?.(value);
          }
        }}
        defaultValue={caseDecisions?.[0]?.id}
      >
        <Space direction="vertical">
          {caseDecisions?.map((item) => {
            return (
              <Row>
                <Radio value={item.id}>{item.name}</Radio>
              </Row>
            );
          })}
        </Space>
      </Radio.Group>
    </>
  );
};
export default CaseDecisionSelectionGroup;
